import React from 'react';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import {
  WORKFLOW_SELECTOR_ARROW_SIZE,
  workflowSelectorArrowOpenStyle,
  workflowSelectorArrowStyle
} from './workflow_selector_appearance';

type Props = {
  open?: boolean;
};

export const WorkflowSelectorArrow: React.FC<Props> = ({ open = false }) => {
  return (
    <span style={{ ...workflowSelectorArrowStyle, ...(open ? workflowSelectorArrowOpenStyle : {}) }}>
      <ArrowDropDownIcon style={{ fontSize: WORKFLOW_SELECTOR_ARROW_SIZE }} />
    </span>
  );
};
